export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA = "SET_DATA";
export const SET_TOTAL = "SET_TOTAL";
